angular.module('ControllersModule')
  .controller('ReactNativeController', function ($rootScope, AccountFactory, $scope, $parse, DeveloperResourcesFactory, DialogFactory, GroupingFactory, SDKTypeFactory) {

  $scope.account = [];
  $scope.sdks = {
    legacy: [],
    radius: [],
    radius3: [],
    point: [],
    sda: []
  };
  $scope.loadingDeveloperInfo = true;
  $scope.isPlatformSdkAvailable = true;

  AccountFactory.getAccount().then(getAccountSuccess, getAccountFailure);

  function getAccountSuccess(data) {
    $scope.account = data.result[0];
    DeveloperResourcesFactory.getSDKInfo('reactnative').then(getSDKInfoSuccess, getSDKInfoFailure);
  }

  function getAccountFailure(data) {
    $scope.loadingDeveloperInfo = false;
    DialogFactory.openDialog($scope, 'There was an error loading the page. Click OK to reload the page.', false, getSDKInfoFailureDialogConfirm);
  }

  function getSDKInfoSuccess(data) {
    var platformReleases = data.result;
    var sortedPlatformReleases = platformReleases.sort(function (a, b) {
      return b.version.localeCompare(a.version, undefined, {
        numeric: true
      });
    });
    var productReleases = GroupingFactory.groupBy(sortedPlatformReleases, 'sdk_type');
    for (var product in productReleases) {
      if (productReleases.hasOwnProperty(product)) {
        var currentProductReleases = productReleases[product];
        var architectureSortedProductReleases = GroupingFactory.groupByArray(currentProductReleases, 'architecture');
        for (var i = 0; i < architectureSortedProductReleases.length; i++) {
          $scope.sdks[product].push(architectureSortedProductReleases[i].values[0]);
        }
      }
    }

    if($scope.sdks.legacy.length < 1 && $scope.sdks.radius.length < 1 && $scope.sdks.point.length < 1 && $scope.sdks.sda.length < 1 && $scope.sdks.radius3.length < 1) {
      $scope.isPlatformSdkAvailable = false;
    }

    $scope.loadingDeveloperInfo = false;
  }

  function getSDKInfoFailure(data) {
    $scope.loadingDeveloperInfo = false;
    DialogFactory.openDialog($scope, 'There was an error loading the page. Click OK to reload the page.', false, getSDKInfoFailureDialogConfirm);
  }

  function getSDKInfoFailureDialogConfirm() {
    $route.reload();
    DialogFactory.closeDialog();
  }

  function closeDialog() {
    DialogFactory.closeDialog();
  }

  $scope.routeAppRequired = function(event) {
    if($rootScope.user.currentapp === null) {
      event.preventDefault();
      DialogFactory.openDialog($scope, 'You must select an app to view the content on this page.', false, DialogFactory.closeDialog);
    }
  }

  $scope.getSDKTypeDisplayName = SDKTypeFactory.getDisplayName;
});
